import img1 from "../img/portImages/MERN-1.jpg";
import img2 from "../img/portImages/game-1.jpg";
import img3 from "../img/portImages/react-1.jpg";
import img4 from "../img/portImages/js-1.png";
import img5 from "../img/portImages/js-2.png";
import img6 from "../img/portImages/game-2.png";
import img7 from "../img/portImages/MERN-2.jpg";
import img8 from "../img/portImages/MERN-3.png";
import img9 from "../img/portImages/react-2.webp";

const portfolios = [
  {
    id: 1,
    category: "MERN",
    image: img1,
    link1: "https://www.github.com/pranay202/Fullstack-Zomato-Clone",
    link2: "https://pranay202.github.io/pranay202/Fullstack-Zomato-Clone",
    title: "Zomato Clone",
    text: "MERN, TailwindCSS, Auth",
  },
  {
    id: 2,
    category: "Games",
    image: img2,
    link1: "https://github.com/pranay202/alienInvasion",
    link2: "https://pranay202.github.io/pranay202/alienInvasion",
    title: "Alien Invasion",
    text: "Python, Pygame",
  },
  {
    id: 3,
    category: "React",
    image: img3,
    link1: "https://github.com/pranay202/Book-My-Show-Clone",
    link2: "https:/pranay202.github.io/pranay202/Book-My-Show-Clone",
    title: "BookMyShow Clone",
    text: "React, TMDB & Razorpay-API",
  },
  {
    id: 4,
    category: "JS",
    image: img4,
    link1: "https://github.com/pranay202/Javascript-Weather-App",
    link2: "https://pranay202.github.io/Javascript-Weather-App/",
    title: "Weather App",
    text: "JS, Weather-API",
  },
  {
    id: 5,
    category: "JS",
    image: img5,
    link1: "https://github.com/pranay202/Task-Management-App",
    link2: "https://pranay202.github.io/Task-Management-App/",
    title: "Tasky - Task Manager",
    text: "JS, CRUD",
  },
  {
    id: 6,
    category: "Games",
    image: img6,
    link1: "https://github.com/pranay202/ColorGame",
    link2: "https://pranay202.github.io/ColorGame/",
    title: "The Color Game",
    text: "JS, Game",
  },
  {
    id: 7,
    category: "MERN",
    image: img7,
    link1: "https://github.com/pranay202/P-Blogs",
    link2: "https://pranay202.github.io/P-Blogs/",
    title: "Blog App",
    text: "MERN, CRUD, Blog",
  },
  {
    id: 8,
    category: "MERN",
    image: img8,
    link1: "https://github.com/pranay202/dashcord-shareview",
    link2: "https://dashcord-student.vercel.app",
    title: "Student Management Portal",
    text: "Next.js, MySQL, Typescript",
  },
  {
    id: 9,
    category: "React",
    image: img9,
    link1: "https://github.com/pranay202/inclusive",
    link2: "https://inclusive-alpha.vercel.app",
    title: "Admin Dashboard",
    text: "React.js, Syncfusion, TailwindCss",
  },
];

export default portfolios;
